import { render, staticRenderFns } from "./FileDropArea.vue?vue&type=template&id=0909b433&scoped=true&lang=pug&"
import script from "./FileDropArea.vue?vue&type=script&lang=ts&"
export * from "./FileDropArea.vue?vue&type=script&lang=ts&"
import style0 from "./FileDropArea.vue?vue&type=style&index=0&id=0909b433&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909b433",
  null
  
)

export default component.exports